// extracted by mini-css-extract-plugin
export default {"container":"sideBar_container__IirfN","header":"sideBar_header__XLCJa","center":"sideBar_center__WACEB"};